import VideoPopUp from "./video-popup";
import ReactDOM from "react-dom";
import {rewriteWavesalias} from "../products/product-page/data-services/data-service";

/*
if data-use-wavesalias = true and window.location.hash === = `#video-${data-autoplay-hash}
<div class=""
data-youtube-popup="Hg_6j1qe4jE"
data-youtube-title="youtube popup"
data-use-wavesalias="true"
data-autoplay-hash="hash-id"
></div>
*/
window.addEventListener('DOMContentLoaded', (event) => {
    const $popups = document.querySelectorAll('[data-youtube-popup]');
    var wavesaliasExists = false;
    $popups.forEach($popup => {
        const youtubeCode = $popup.getAttribute('data-youtube-popup');
        const youtubeTitle = $popup.getAttribute('data-youtube-title');

        const youtubeWavesalias = $popup.getAttribute('data-use-wavesalias') !== 'false';
        if(youtubeWavesalias && !wavesaliasExists){
            rewriteWavesalias();
            wavesaliasExists = true;
        }

        const youtubeAutoplayHash = $popup.getAttribute('data-autoplay-hash') || '';

        const $placeholder = document.createElement('div');
        ReactDOM.render(
            <VideoPopUp
                youtubeCode={ youtubeCode || '' }
                youtubeTitle={ youtubeTitle || '' }
                youtubeAutoplayHash={youtubeAutoplayHash}
                $button={ $popup as HTMLElement }
            />,
            $placeholder
        );
        document.body.appendChild($placeholder);
    });

});

export {};